import { render, staticRenderFns } from "./LogginRecover.vue?vue&type=template&id=42d9d93e&"
import script from "./LogginRecover.vue?vue&type=script&lang=js&"
export * from "./LogginRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports